module.exports = __webpack_public_path__ + "img/arrow-right-ai.13a117cb.svg";